<script lang="ts">
    import { createEventDispatcher, onMount, tick } from 'svelte'
    import Fa from 'svelte-fa'
    import { faPlus, faTrashAlt, faSave, faPrint, faEdit } from '@fortawesome/free-solid-svg-icons'
    import { InvoicesRepository } from '../../modules/posApi/invoices/invoices.repository'
    import { InvoicesService } from '../../modules/posApi/invoices/invoices.service'
    import { Invoice, PaymentMethodsOnInvoices, ServicesOnInvoices } from '../../modules/posApi/invoices/invoice'
    import ZentitySelect from '../_common/z/zentity-select.svelte'
    import PosEntriesItem from './pos-entries-item.svelte'
    import PosEntriesPayment from './pos-entries-payment.svelte'
    import Zact from '../_common/z/zact.svelte'
    import Zbutton from '../_common/z/zbutton.svelte'
    import Zinput from '../_common/z/zinput.svelte'
    import { User } from '../../modules/usersApi/users/user'
    import type { Person } from '../../modules/eventsApi/persons/person'
    import { PersonsRepository } from '../../modules/eventsApi/persons/persons.repository'
    import { PersonsService } from '../../modules/eventsApi/persons/persons.service'
    import { Store } from '../../modules/infra/store.service'
    import { CompaniesRepository } from '../../modules/usersApi/companies/companies.repository'
    import { CompaniesService } from '../../modules/usersApi/companies/companies.service'
    import type { Appointment } from '../../modules/schedulerApi/appointments/appointment'
    import dayjs from 'dayjs'
    import Popover from '../_common/popover.svelte'
    import PosFormDiscount from './pos-form-discount.svelte'
    import { posCashier } from '../_common/stores'
    import AppointmentsSelect from '../agenda/appointments-select.svelte'
    import type { AppointmentsSelectEntity } from '../agenda/appointments-select.entity'
    import { AppointmentStatus } from '../../modules/schedulerApi/appointments/appointments.enum'
    import type { QuotationEntity } from '../../modules/posApi/quotation/quotation.entity'
    import ZContainer from '../_common/z/z-container.svelte'
    import ZContainerCol from '../_common/z/z-container-col.svelte'
    import ReferralSelect from '../account/referrals/referral-select.svelte'
    import { Referral } from '../../modules/eventsApi/referrals/referral'
    import PosSheet from './v4/pos-sheet.svelte'

    const dispatch = createEventDispatcher()

    const rep = new InvoicesRepository()
    const service = new InvoicesService(rep)

    const compR = new CompaniesRepository()
    const compS = new CompaniesService(compR)
    let users: User[] = []

    export let invoiceId: string = null
    export let budget: boolean = false
    export let appointment: Appointment = null
    export let quotation: QuotationEntity = null
    export let print: boolean = false

    let personsR = new PersonsRepository()
    let personsS = new PersonsService(personsR)
    let persons: Person[] = []

    let show = false
    let entity: Invoice = new Invoice()
    let createdAt: Date = new Date()
    let newService: boolean = false
    let newPayment: boolean = false
    let referral: Referral = null

    $: entity.referralId = referral?.referralId || undefined

    let valuePending = 0

    let cashierId: string = null
    posCashier.subscribe(async (value) => {
        users = await compS.getCompanyUsers()
        cashierId = value?.cashierId || null
        if (invoiceId) {
            await loadEntity(invoiceId)
            if (print) goPrint()
        } else {
            newEntity()
        }
    })

    onMount(async () => {})

    function goPrint() {
        setTimeout(() => {
            window.print()
            dispatch('change')
        }, 600)
    }

    let noPaid: number = 0
    async function loadInvoices() {
        noPaid = 0
        if (!entity?.person?.personId) return
        noPaid = await window.api.pos.invoices.getCreditAndDebitsFromPerson(entity.person.personId || entity.personId)
    }

    async function loadEntity(id: string) {
        try {
            show = true
            entity = new Invoice()
            entity = await service.getOne(id)
            if (!entity || entity.status === 'removed') {
                newEntity()
                return
            }
            createdAt = new Date(entity.createdAt)
            referral = entity.referralId ? ({ referralId: entity.referralId, label: '' } as Referral) : null
            await updatePerson()
            entity.user = users.find((el) => el.userId === entity?.userId)
            for (let service of entity.services) {
                service.user = users.find((el) => el.userId === service?.userId)
                if (!service.user) {
                    service.user = new User()
                    service.user.userId = service?.userId
                    service.user.userName = '[usuário excluído]'
                }
            }
            updateCounters()
            await loadInvoices()
            console.log('invoice', entity)
        } catch (error) {
            evaluateError(error)
        } finally {
            show = false
        }
    }

    async function updatePerson() {
        console.log('updating person')
        const personId = entity?.personId || entity?.person?.personId
        if (!personId) return
        entity.person = await personsS.getOne(personId)
        console.log('update success')
    }

    let step = 1
    async function newEntity() {
        if (window.configs?.allowCashierStatus) {
            cashierId = (await window.api.pos.cashiers.opened())?.cashierId
            if (!cashierId) {
                step = 2
                return
            }
        }
        entity = new Invoice()
        entity.createdAt = new Date(createdAt)
        entity.discountFixed = 0
        entity.discountPercentage = 0
        entity.services = []
        entity.payments = []
        entity.cashierId = cashierId
        referral = null
        updateCounters()
        let store: Store = new Store()
        entity.user = users.find((el) => el.userId === store.token.userId)

        if (appointment) {
            entity.person = appointment.person
            entity.personId = appointment.personId
            entity.appointmentId = appointment.appointmentId
            entity.notes = 'Criado a partir da agenda do dia ' + dayjs(appointment.start).format('DD/MM/YYYY')
            for (const item of appointment.items) {
                let invoiceItem: ServicesOnInvoices = new ServicesOnInvoices()
                invoiceItem.comissionCosts = item.service.comissionCosts
                invoiceItem.comissionFixed = item.service.comissionFixed
                invoiceItem.comissionPercentage = (item.service.price * item.service.comissionPercentage) / 100
                invoiceItem.valueTable = item.service.price
                invoiceItem.valueGross = item.service.price
                invoiceItem.value = item.service.price
                invoiceItem.quantity = 1
                invoiceItem.service = item.service
                invoiceItem.serviceId = item.serviceId
                invoiceItem.user = users.find((el) => el.userId === item.userId)
                invoiceItem.parentServiceId = item.service.type === 'package' ? item.service.serviceId : null
                if (!invoiceItem.user) {
                    invoiceItem.user = new User()
                    invoiceItem.user.userId = item.userId
                }
                invoiceItem.userId = item?.userId
                entity.services.push(invoiceItem)
            }
            entity = entity
            console.log('appointment_exp', appointment)

            await loadInvoices()
            updateCounters()
        }

        if (quotation) {
            entity.person = quotation.person
            entity.personId = quotation.personId
            entity.quotationId = quotation.quotationId
            entity.notes = 'Criado a partir do orçamento do dia ' + dayjs(quotation.createdAt).format('DD/MM/YYYY')
            for (const item of quotation.items) {
                let invoiceItem: ServicesOnInvoices = new ServicesOnInvoices()
                invoiceItem.comissionCosts = item.service.comissionCosts
                invoiceItem.comissionFixed = item.service.comissionFixed
                invoiceItem.comissionPercentage = (item.value * item.service.comissionPercentage) / 100
                invoiceItem.valueTable = item.service.price
                invoiceItem.valueGross = item.value
                invoiceItem.value = item.value // valor após desconto, se aplicado
                invoiceItem.quantity = item.quantity
                invoiceItem.service = item.service
                invoiceItem.serviceId = item.serviceId
                invoiceItem.user = users.find((el) => el.userId === quotation.userId)
                invoiceItem.parentServiceId = item.parentServiceId
                if (!invoiceItem.user) {
                    invoiceItem.user = new User()
                    invoiceItem.user.userId = quotation.userId
                }
                invoiceItem.userId = quotation.userId
                entity.services.push(invoiceItem)
            }
            entity = entity
            console.log('quotation_exp', quotation)

            await loadInvoices()
            updateCounters()
        }
    }

    async function saveEntity(_budget: boolean) {
        upsertEntity(_budget)
    }

    async function upsertEntity(_budget: boolean) {
        try {
            if (show) return
            show = true

            if (!createdAt) {
                evaluateError('Informe data e hora de lançamento válidos (1)')
                return false
            }
            const createdAtDate = new Date(createdAt)
            // verifica se createdAtDate é uma data válida
            if (!window.api.utils.dates.isValid(createdAtDate)) {
                evaluateError('Informe data e hora de lançamento válidos (2)')
                return false
            }
            const diffYears = dayjs(createdAtDate).diff(new Date(), 'y')
            if (diffYears < -100) {
                evaluateError('Informe data e hora de lançamento válidos (3)')
                return false
            }

            // limpa itens nulos
            entity.services = entity.services.filter((el) => !!el)
            entity.payments = entity.payments.filter((el) => !!el)

            evaluateDiscountsAndComissions()
            for (const pm of entity.payments) {
                pm.paymentMethodId = pm.paymentMethod.paymentMethodId
            }

            const dto: Partial<Invoice> = {
                invoiceId: entity.invoiceId || undefined,
                appointmentId: entity.appointmentId || undefined,
                discountFixed: entity.discountFixed,
                discountPercentage: entity.discountPercentage,
                createdAt: new Date(createdAt),
                notes: entity.notes,
                cashierId: entity.cashierId || undefined,
                referralId: entity.referralId || undefined,
                personId: entity.person?.personId,
                payments: entity.payments,
                status: _budget ? 'budget' : undefined,
                services: entity.services
                    .filter((el) => !!el)
                    .map((el) => {
                        console.log('el...', el)
                        return {
                            comissionFixed: 0,
                            comissionPercentage: 0,
                            comissionFeeDebt: 0,
                            comissionCanceled: undefined,
                            quantity: el.quantity,
                            serviceId: el.service.serviceId,
                            userId: el.user.userId,
                            value: el.value,
                            valueGross: el.valueGross,
                            valueTable: el.parentServiceId ? el.valueTable : el.valueTable || el.service.price,
                            comissionCosts: el.comissionCosts,
                            type: el.service.type,
                            parentServiceId: el.parentServiceId,
                            fee: el.fee,
                        }
                    }),
                userId: entity.user?.userId,
            }

            if (!(await validateDto(dto))) return false
            const res = await service.upsert(dto)
            if (!entity.invoiceId) {
                window.api.users.statistics.tick('invoice.create')
            }
            await checkAppointmentPaid(res.invoiceId)
            dispatch('change', res)
        } catch (error) {
            window.error(error)
        } finally {
            show = false
        }
    }

    async function checkAppointmentPaid(invoiceId: string) {
        for (const id of appointmentPaid) {
            const comissionSource = await window.flags('schedulerComission')
            await window.api.schedulers.appointments.setPaid(id, {
                invoiceId: invoiceId,
                comissionSource,
                voidComission: false,
                status: appointmentAttended ? AppointmentStatus.agendamento_compareceu : undefined,
            })
        }
    }

    let personIncomplete = false
    async function validateDto(dto: Partial<Invoice>) {
        if (!dto.personId) {
            evaluateError('Selecione o cliente')
            return false
        }
        if (dto.services.length === 0 && dto.payments.length === 0) {
            evaluateError('Você deve informar ao menos um serviço e/ou um valor pago')
            return false
        }
        if (dto.services.length === 0) {
            if (budget) {
                evaluateError('Você deve informar ao menos um serviço para este orçamento')
                return false
            } else {
                if (!confirm('Você não informou um serviço.\nDeseja mesmo lançar apenas a entrada de crédito para o cliente?')) {
                    return false
                }
            }
        }
        if (dto.services.length > 0 && dto.services.reduce((acc, el) => (acc += el.value), 0) < 0) {
            evaluateError('Informe um valor válido para todos os serviços')
            return false
        }
        for (const item of dto.services) {
            if (!item.userId) {
                evaluateError('Todos os itens devem possuir um vendedor.')
                return false
            }
        }
        if (!budget && dto.services.length > 0 && dto.payments.length === 0 && valuePending > 0) {
            if (!confirm('Você não informou o meio de pagamento.\nO lançamento ficará com status "aberto".\nDeseja continuar?')) {
                return false
            }
        }

        if (window.configs.posRequired && window.configs.posRequired.length > 0) {
            if (personIncomplete) {
                await updatePerson()
            }
            personIncomplete = false
            if (window.configs.posRequired.includes('e-mail') && (!entity?.person?.email || entity?.person?.email.includes('@') === false)) {
                evaluateError('Cadastro da pessoa está incompleto. Informe o e-mail antes de concluir a venda.')
                personIncomplete = true
                return false
            }
            if (window.configs.posRequired.includes('origem') && !entity?.person?.referralId) {
                evaluateError('Cadastro da pessoa está incompleto. Informe a origem do cliente antes de concluir a venda.')
                personIncomplete = true
                return false
            }
            if (window.configs.posRequired.includes('document') && !entity?.person?.document && !entity?.person?.passport) {
                evaluateError('Cadastro da pessoa está incompleto. Informe o CPF/CNPJ/Passaporte antes de concluir a venda.')
                personIncomplete = true
                return false
            }
            if (
                window.configs.posRequired.includes('endereco') &&
                (!entity?.person?.address || !entity?.person?.city || !entity?.person?.CEP || !entity?.person?.district)
            ) {
                evaluateError('Cadastro da pessoa está incompleto. Informe o endereço antes de concluir a venda.')
                personIncomplete = true
                return false
            }
        }

        personIncomplete = false

        if (!checkDiscountLimits(dto)) return false

        return true
    }

    function checkDiscountLimits(dto: Partial<Invoice>) {
        if (window.store.token.permissions.pos.sales.discount === null) return true
        if (window.store.token.permissions.pos.sales.discount === undefined) return true
        if (window.store.token.permissions.pos.sales.discount >= 100) return true
        console.log('discountDTO', dto)
        const serviceTotalTable = dto.services.reduce((acc, el) => (acc += el.valueTable * el.quantity), 0)
        const serviceTotal = dto.services.reduce((acc, el) => (acc += (el.value || 0) * (el.quantity || 0)), 0)
        if (!serviceTotalTable) return true
        const discountPercentage = ((serviceTotalTable - serviceTotal) / serviceTotalTable) * 100
        console.log('discountPercentage', discountPercentage, serviceTotalTable, serviceTotal)
        if (discountPercentage <= window.store.token.permissions.pos.sales.discount) {
            return true
        }
        window.error(
            `O desconto total ultrapassa o limite permitido de ${window.store.token.permissions.pos.sales.discount}%\nDesconto atual: ${discountPercentage.toFixed(2)}%`,
        )
        return false
    }

    async function removeEntity() {
        if (!confirm('Deseja mesmo excluir este registro?')) {
            return
        }
        try {
            show = true
            await service.remove(entity.invoiceId)
            dispatch('change')
        } catch (error) {
            evaluateError(error)
        } finally {
            show = false
        }
    }

    async function newServiceItem() {
        newService = true
    }

    let showImport = false
    async function newServiceItemFromImport() {
        showImport = true
    }

    function addNestedItems(parent: ServicesOnInvoices, position: number) {
        if (!Array.isArray(parent.service?.services)) return
        let count = 0
        for (const nested of parent.service.services) {
            let invoiceItem: ServicesOnInvoices = new ServicesOnInvoices()
            invoiceItem.comissionCosts = nested.service.comissionCosts
            invoiceItem.comissionFixed = nested.service.comissionFixed
            invoiceItem.comissionPercentage = (nested.price * nested.service.comissionPercentage) / 100
            invoiceItem.valueTable = nested.price
            invoiceItem.valueGross = nested.price
            invoiceItem.value = nested.price
            invoiceItem.quantity = nested.quantity
            invoiceItem.service = nested.service
            invoiceItem.serviceId = nested.serviceId
            invoiceItem.parentServiceId = parent.service.serviceId
            invoiceItem.user = parent.user
            invoiceItem.userId = parent.userId
            count++
            entity.services.splice(position + count, 0, invoiceItem)
        }
    }

    async function serviceAdded(event, position) {
        console.log('added', event.detail)

        entity.services.push(event.detail)
        if (event.detail.service.type === 'package') {
            addNestedItems(event.detail, position + 1)
        }
        entity.services = entity.services
        newService = false
        evaluateDiscountsAndComissions()
    }

    function serviceRemovePackageChilds(packagePosition: number) {
        // antes de mais nada, se é edição de um child, então sai
        if (entity.services[packagePosition].parentServiceId) return
        entity.services = entity.services.filter((el) => !!el)
        for (let index = packagePosition + 1; index < entity.services.length; index++) {
            // se não é mais um child, ou seja, não tem parent
            if (!entity.services[index].parentServiceId) break
            entity.services[index] = null
        }
        entity.services = entity.services.filter((el) => !!el)
    }

    function serviceRemoveOrphanChilds() {
        // se removeu um pacote, remove os itens adicionados
        let remove = false
        for (let index = 0; index < entity.services.length; index++) {
            if (remove) {
                // se deve remover, e é um child, então remove
                if (entity.services[index].parentServiceId) {
                    entity.services[index] = null
                }
            }
            // se o service é null/undefined, então foi excluído agora. portanto seta removed=true para excluir os próximos itens
            remove = !entity.services[index]
        }
        entity.services = entity.services.filter((el) => !!el)
    }

    function serviceClosed() {
        newService = false
        serviceRemoveOrphanChilds()
        // atribui o user para os childs (pois somente o pacote recebe o user dentro do pos-entries-item)
        for (let index = entity.services.length - 1; index >= 0; index--) {
            if (!entity.services[index]?.parentServiceId) continue
            const found = entity.services.find((el) => el?.service?.serviceId === entity.services[index].parentServiceId)
            if (!found) continue
            entity.services[index].user = found.user
            entity.services[index].userId = found.userId
        }
        entity.services = entity.services.filter((el) => !!el)
        evaluateDiscountsAndComissions()
    }

    async function newPaymentMethod() {
        newPayment = true
    }

    async function paymentMethodAdded(event) {
        entity.payments.push(event.detail)
        entity.payments = entity.payments
        newPayment = false
        updateCounters()
    }

    function paymentMethodClose() {
        newPayment = false
        updateCounters()
    }

    function evaluateError(error) {
        window.error(error)
    }

    let budgetDate = null
    function convertToInvoice() {
        budgetDate = createdAt
        budget = false
        window.alert('Faturado com sucesso.\nAtenção: lembre-se de ajustar a forma de pagamento do cliente.')
    }
    function convertToBudget() {
        createdAt = budgetDate
        budget = true
    }

    let showDiscount = false
    function discountOnChange() {
        evaluateDiscountsAndComissions()
        showDiscount = false
    }

    function evaluateDiscountsAndComissions() {
        console.log('evaluateDiscountsAndComissions', entity.services)
        let total = entity.services.reduce((acc, item) => {
            if (item.service.type === 'package') return acc
            acc += item.valueGross * item.quantity
            return acc
        }, 0)
        for (const item of entity.services) {
            if (item.service.type === 'package') continue
            if (entity.discountPercentage > 0) {
                item.value = item.valueGross - item.valueGross * (entity.discountPercentage / 100)
                // item.value = item.valueGross - Math.round(item.valueGross * 100 * (entity.discountPercentage / 100)) / 100
            } else if (entity.discountFixed > 0) {
                item.value = item.valueGross - (((item.valueGross * item.quantity) / total) * entity.discountFixed) / item.quantity
            } else {
                item.value = item.valueGross
            }
        }
        //evaluateComissions()
        updateCounters()
    }

    function evaluateComissions() {
        for (const item of entity.services) {
            item.comissionCosts = item.service.comissionCosts * item.quantity
            item.comissionFixed = item.service.comissionFixed * item.quantity
            item.comissionPercentage = (item.value * item.quantity * item.service.comissionPercentage) / 100
        }
    }

    let totalGross = 0
    function updateCounters() {
        setTimeout(() => {
            totalGross = entity.services.reduce((total, el) => (total += el?.valueGross * el?.quantity || 0), 0)
            entity.total = entity.services.reduce((total, el) => (total += el?.value * el?.quantity || 0), 0)
            entity.totalPaid = entity.payments.reduce((total, el) => (total += el?.value || 0), 0)
            valuePending = entity.total - entity.totalPaid
        }, 100)
    }

    // ---- folha do mobile (v4) ----
    // No mobile a mesma lógica deste arquivo é apresentada pela folha (./v4/pos-sheet.svelte), que recebe
    // o estado e chama as funções daqui — nenhuma regra é duplicada. Na impressão volta o formulário
    // antigo: é nele que vivem as classes de impressão (s-print/h-print) do orçamento.
    // Mesmo critério da agenda (schedules-container), para a venda e o agendamento concordarem
    // sobre o que é "mobile": quem decide qual tela abrir é a largura da tela do aparelho.
    const isMobile = screen.width <= 900
    let printingLegacy = false
    $: useSheet = isMobile && !print && !printingLegacy

    async function printFromSheet() {
        printingLegacy = true
        await tick()
        window.print()
        printingLegacy = false
    }

    // o formulário antigo chama as duas no change do cliente
    async function personChangedFromSheet() {
        await updatePerson()
        await loadInvoices()
    }

    let appointmentPaid: string[] = []
    let appointmentAttended: boolean = false
    async function onAppointmentImport(ev) {
        showImport = false
        appointmentAttended = false
        appointmentPaid = []
        if (!ev.detail) return
        const aps: AppointmentsSelectEntity = ev.detail
        appointmentAttended = aps.statusAttended
        for (const ap of aps.appointments) {
            appointmentPaid.push(ap.appointment.appointmentId)
            // ==========================
            entity.person = ap.person
            entity.personId = ap.personId
            entity.appointmentId = ap.appointment.appointmentId
            entity.notes = 'Importado da agenda do dia ' + dayjs(ap.appointment.start).format('DD/MM/YYYY')
            for (const item of ap.items) {
                let invoiceItem: ServicesOnInvoices = new ServicesOnInvoices()
                invoiceItem.comissionCosts = item.item.service.comissionCosts
                invoiceItem.comissionFixed = item.item.service.comissionFixed
                invoiceItem.comissionPercentage = (item.item.service.price * item.item.service.comissionPercentage) / 100
                invoiceItem.valueTable = item.item.service.price
                invoiceItem.valueGross = item.item.service.price
                invoiceItem.value = item.item.service.price
                invoiceItem.quantity = 1
                invoiceItem.service = item.item.service
                invoiceItem.serviceId = item.item.serviceId
                invoiceItem.user = users.find((el) => el.userId === item.item.userId)
                invoiceItem.parentServiceId = item.item.service.type === 'package' ? item.item.service.serviceId : null
                if (!invoiceItem.user) {
                    invoiceItem.user = new User()
                    invoiceItem.user.userId = item.item.userId
                }
                invoiceItem.userId = item.item.userId
                entity.services.push(invoiceItem)
            }
        }
        entity = entity
        updateCounters()
        await loadInvoices()
    }
</script>

{#if showDiscount}
    <Popover on:close={() => (showDiscount = false)} width="600px" height="200px">
        <PosFormDiscount bind:discountFixed={entity.discountFixed} bind:discountPercentage={entity.discountPercentage} on:change={discountOnChange} />
    </Popover>
{/if}

{#if showImport}
    <Popover on:close={() => (showImport = false)} width="920px" height="120px">
        <AppointmentsSelect personId={entity.person?.personId || entity.personId} on:import={onAppointmentImport}></AppointmentsSelect>
    </Popover>
{/if}

{#if step === 2}
    <div class="m-5">
        <div class="alert alert-warning text-center">
            O seu caixa está fechado.<br />Antes de realizar um lançamento abra seu caixa no PDV.<br />
            Erro: O caixa do usuário {window.store.user.userName} está fechado.
        </div>
    </div>
{:else if useSheet}
    <PosSheet
        bind:entity
        bind:createdAt
        bind:referral
        bind:newService
        bind:newPayment
        {budget}
        {valuePending}
        {totalGross}
        {noPaid}
        {show}
        onSave={() => saveEntity(budget)}
        onRemove={removeEntity}
        onPrint={printFromSheet}
        onConvertToInvoice={convertToInvoice}
        onConvertToBudget={convertToBudget}
        onPersonChange={personChangedFromSheet}
        onImport={newServiceItemFromImport}
        onServiceAdded={serviceAdded}
        onServiceClosed={serviceClosed}
        onPaymentAdded={paymentMethodAdded}
        onPaymentClosed={paymentMethodClose}
        onDiscountChange={evaluateDiscountsAndComissions}
    />
{:else}
    <div class="root m-bottom-sm">
        <Zact>
            <!-- Cliente e saldo moram na barra, ao lado do Salvar, como na agenda
                 (appointment-form.svelte): é o primeiro dado da venda e o alerta de saldo precisa
                 ser visto antes de fechar, não no meio do formulário. O campo cresce e empurra os
                 botões para a direita, por isso aqui não há mais o espaçador. -->
            <div class="act-person">
                <ZentitySelect
                    fonte="pessoa"
                    on:change={loadInvoices}
                    disabled={!!entity.invoiceId}
                    label="Cliente"
                    on:change={updatePerson}
                    bind:value={entity.person}
                />
            </div>
            {#if noPaid > 0.1}
                <div class="alert alert-warning mb-0 act-balance text-center">
                    Saldo em aberto de {noPaid.toFixed(2)}
                </div>
            {/if}
            {#if noPaid < -0.1}
                <div class="alert alert-success mb-0 act-balance text-center">
                    Saldo positivo de {(-noPaid).toFixed(2)}
                </div>
            {/if}
            {#if window.store.token.permissions.pos.sales.write}
                {#if !!entity.invoiceId}
                    <Zbutton color="red" icon={faTrashAlt} label="Excluir" disabled={show} on:click={removeEntity} />
                {/if}
                {#if entity.status === 'budget'}
                    <Zbutton color="secondary" icon={faPrint} label="Imprimir" on:click={() => window.print()} />

                    {#if budget}
                        <Zbutton color="secondary" icon={faSave} label="Converter para venda" on:click={convertToInvoice} />
                    {:else}
                        <Zbutton color="secondary" icon={faSave} label="Converter para orçamento" on:click={convertToBudget} />
                    {/if}
                {/if}
                <Zbutton color="primary" icon={faSave} label="Salvar" loading={show} disabled={show} on:click={() => saveEntity(budget)} />
            {/if}
        </Zact>
        <div class="">
            <div class="config-box mt-2 mx-2">
                <ZContainer>
                    <ZContainerCol size={4} sizeM={12}><Zinput type="datetime" label="Data do lançamento" bind:value={createdAt} /></ZContainerCol>
                    <ZContainerCol size={4} sizeM={12}><ReferralSelect label="Origem" bind:referral /></ZContainerCol>
                    <ZContainerCol size={4} sizeM={12}>
                        {#if !budget}
                            <Zinput label="Anotações" bind:value={entity.notes} />
                        {/if}</ZContainerCol
                    >
                </ZContainer>
            </div>

            <div class="config-box mt-2 mx-2">
                <div class="row mt-2-sm mx-0">
                    <div class="col">
                        {#if budget}
                            <div class="-title h-mobile s-print">Itens no Orçamento</div>
                        {:else}
                            <div class="-title h-mobile s-print">Itens</div>
                        {/if}

                        {#if entity.services?.length > 0}
                            <div class="grid-head h-mobile">
                                <div class="row">
                                    <div class="col-2 h-print">Vendedor</div>
                                    <div class="col">Serviço</div>
                                    <div class="col-md-1 text-end">Valor Unit</div>
                                    <div class="col-md-1 text-end">Qtde</div>
                                    <div class="col-md-1 text-end">Total</div>
                                    <div class="col-md-2" />
                                </div>
                            </div>
                            <div class="grid-body">
                                {#each entity.services as item, index}
                                    <PosEntriesItem class="py-1 liner" bind:invoiceItem={item} on:cancel={serviceClosed} on:added={serviceClosed} />
                                {/each}
                            </div>
                        {/if}
                        <div class="mt-2 mb-2">
                            {#if newService}
                                <PosEntriesItem class="py-1" on:cancel={serviceClosed} on:added={(ev) => serviceAdded(ev, entity.services.length - 1)} />
                            {:else}
                                <div class="add-item d-flex">
                                    <Zbutton class="me-2" grow={window.api.utils.utils.isMobile()} on:click={newServiceItem} icon={faPlus} label="Adicionar..."
                                    ></Zbutton>
                                    <Zbutton
                                        grow={window.api.utils.utils.isMobile()}
                                        on:click={newServiceItemFromImport}
                                        icon={faPlus}
                                        label="Importar da agenda..."
                                    ></Zbutton>
                                </div>
                            {/if}
                        </div>
                    </div>
                </div>
            </div>

            <div class="config-box mt-2 mx-2">
                <div class="row mx-0">
                    <div class="col">
                        {#if budget}
                            <div class="-title h-mobile s-print">Alternativas de pagamento</div>
                        {:else}
                            <div class="-title h-mobile s-print">Pagamento</div>
                        {/if}

                        {#if entity.payments?.length > 0}
                            <div class="grid-head h-mobile">
                                <div class="row">
                                    <div class="col">Meio de pagamento</div>
                                    <div class="col-md-1 text-end">Parcelas</div>
                                    <div class="col-md-1 text-end">Total</div>
                                    <div class="col-md-2" />
                                </div>
                            </div>
                            <div class="grid-body">
                                {#each entity.payments as item}
                                    <PosEntriesPayment
                                        pendingTotal={valuePending}
                                        class="py-1 liner"
                                        on:cancel={paymentMethodClose}
                                        on:added={paymentMethodClose}
                                        bind:invoicePayment={item}
                                    />
                                {/each}
                            </div>
                        {/if}
                        <div class="mt-2 mb-2">
                            {#if newPayment}
                                <PosEntriesPayment class="py-1" pendingTotal={valuePending} on:cancel={paymentMethodClose} on:added={paymentMethodAdded} />
                            {:else}
                                <div class="add-item">
                                    <Zbutton grow={window.api.utils.utils.isMobile()} on:click={newPaymentMethod} icon={faPlus} label="Adicionar..."></Zbutton>
                                </div>
                            {/if}
                        </div>
                    </div>
                </div>
            </div>
            {#if budget}
                <div class="config-box mt-2 mx-2">
                    <div class="row mb-1">
                        <div class="col">
                            <div class="input-group">
                                <label for="" class="input-group-text">Anotações</label>
                                <textarea bind:value={entity.notes} placeholder="" class="form-control h-print" rows="5" />
                                <div class="notes-wrap h-screen">{entity.notes}</div>
                            </div>
                        </div>
                    </div>
                </div>
            {/if}
            {#if !budget}
                <div class="row pending mb-1 m-2">
                    <div class="col px-md-0">
                        <div class="box">
                            <div class="label">Itens</div>
                            <div class="value">{totalGross?.toFixed(2)}</div>
                        </div>
                        <div class="box discount">
                            <div class="label">Desconto</div>
                            {#if entity.discountPercentage > 0}
                                <div class="value">{entity.discountPercentage}%</div>
                            {:else}
                                <div class="value">
                                    {window.api.utils.utils.toReal(entity?.discountFixed ? entity?.discountFixed : 0)}
                                </div>
                            {/if}

                            <button class="btn btn-secondary btn-sm w-discount" on:click={() => (showDiscount = true)}><Fa icon={faEdit} /></button>
                        </div>
                        <div class="box h-mobile">
                            <div class="label">Pago</div>
                            <div class="value">{entity.totalPaid?.toFixed(2)}</div>
                        </div>
                        <div class="box" class:background_yellow={valuePending !== 0}>
                            {#if valuePending >= 0}
                                <div class="label">Em aberto</div>
                                <div class="value">{valuePending.toFixed(2)}</div>
                            {:else}
                                <div class="label">Crédito ao cliente</div>
                                <div class="value">{(valuePending * -1).toFixed(2)}</div>
                            {/if}
                        </div>
                    </div>
                </div>

                <!-- o saldo do cliente saiu daqui: agora fica na barra de ações, junto do nome dele -->
            {/if}
        </div>
    </div>
{/if}

<style>
    /* cliente e saldo dentro da barra de ações, no mesmo arranjo da agenda: o campo cresce e
       empurra os botões para a direita; o aviso de saldo fica entre os dois */
    .act-person {
        flex: 1 1 260px;
        min-width: 220px;
    }
    .act-balance {
        padding: 9px;
        flex: 0 1 auto;
    }
    .config-box .-title {
        font-size: 20px;
    }
    .pending .col {
        display: flex;
    }
    .pending .box {
        flex: 1 1 10px;
        margin: 0px 6px 0px 6px;
        background: #99999925;
        font-size: 17px;
        display: flex;
        border-radius: 4px;
    }
    .pending .box:first-child {
        margin-left: 0px;
    }
    .pending .box:last-child {
        margin-right: 0px;
    }
    .pending .box > * {
        flex: 1 1 10px;
        padding: 8px;
    }

    .pending .box .label {
        text-align: center;
    }

    .pending .box .value {
        text-align: center;
    }

    .w-discount {
        max-width: 50px;
    }

    .notes-wrap {
        white-space: pre-wrap;
    }

    @media (max-width: 900px) {
        .w-discount {
            max-width: unset;
        }

        .root {
            display: flex;
            flex-direction: column-reverse;
        }
        .add-item {
        }
        .pending {
            margin-top: 12px;
        }
        .pending .box {
            flex-direction: column;
        }
        .pending .box > * {
            padding: 4px;
        }
        .add-item {
        }
        .config-box {
            margin-top: 16px;
        }
    }
</style>
